import { useEffect, useState, useRef } from "react";
import { NumericFormat } from "react-number-format";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useReactToPrint } from "react-to-print";
import { reportCRUD } from "../../actions/report";
import { Loading } from "../constant";
import { PrintHeader } from "../../layout/PrintHeader";
import { BoundaryCascade } from "./BoundaryCascade";

export const Report3 = () => {
  const tableRef = useRef(null);
  const dataRef = useRef(null);

  const [dataMale, setDataMale] = useState([]);
  const [dataFemale, setDataFemale] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [boundaryId, setBoundaryId] = useState(null);
  const [boundaryName, setBoundaryName] = useState(null);

  const loadReport = (bid) => {
    setLoading(true);
    setLoadError(null);
    reportCRUD
      .loadMemberSummaryReport(bid)
      .then((resp) => {
        setDataMale(resp.data.result_male || []);
        setDataFemale(resp.data.result_female || []);
      })
      .catch((err) => {
        // Surface the failure instead of showing a silent blank page.
        setDataMale([]);
        setDataFemale([]);
        setLoadError(
          err?.response?.status
            ? `Failed to load report (HTTP ${err.response.status}).`
            : "Failed to load report. Please try again."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Initial load = user's own scope (no boundary selected).
  useEffect(() => {
    loadReport(null);
  }, []);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Summary Report</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="#">Report</a>
                      </li>
                      <li className="breadcrumb-item active">Form 3</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row align-items-end">
                      <div className="col-md-9">
                        <BoundaryCascade onChange={(id, name) => { setBoundaryId(id); setBoundaryName(name); }} />
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => loadReport(boundaryId)}
                        >
                          <i className="bi bi-funnel"></i> &nbsp; Generate{boundaryName ? ` — ${boundaryName}` : ' (my area)'}
                        </button>
                      </div>
                      {!loading && (
                        <div className="col-md-3">
                          <div className="row d-flex justify-content-end">
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-danger"
                                onClick={handleGeneratePdf}
                              >
                                <i className="bi bi-file-earmark-pdf bi-lg"></i>
                                &nbsp; PDF
                              </button>
                            </div>
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-soft-success"
                              >
                                <DownloadTableExcel
                                  filename="summary report"
                                  sheet="summary"
                                  currentTableRef={tableRef.current}
                                >
                                  <i className="bi bi-file-earmark-excel bi-lg"></i>
                                  &nbsp; Excel
                                </DownloadTableExcel>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="card-body" ref={dataRef}>
                    <PrintHeader subtitle={`Socio-Economic & Health Report${boundaryName ? ` — ${boundaryName}` : ''}`} />
                    <table
                      ref={tableRef}
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "80px" }}>SR No.</th>
                          <th className="d-flex justify-content-center">
                            Description
                          </th>
                          <th style={{ width: "180px" }}>Male</th>
                          <th style={{ width: "180px" }}>Female</th>
                          <th style={{ width: "180px" }}>Total</th>
                        </tr>
                      </thead>
                      {!loading && (
                        <tbody>
                          <tr>
                            <td className="text-end">1</td>
                            <td>Number of household members</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[0].total_member : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[0].total_member : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[0].total_member +
                                      dataFemale[0].total_member
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">2</td>
                            <td>Number of Infants under 1 year</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[1].total_infant : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[1].total_infant : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[1].total_infant +
                                      dataFemale[1].total_infant
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">3</td>
                            <td>Number of children under 5 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[2].total_under_5 : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[2].total_under_5 : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[2].total_under_5 +
                                      dataFemale[2].total_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">4</td>
                            <td colSpan={4}>Nutrition Information</td>
                          </tr>
                          <tr>
                            <td className="text-end">a</td>
                            <td>Good members under 5 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[3].total_nutrition_good_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[3].total_nutrition_good_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[3].total_nutrition_good_under_5 +
                                      dataFemale[3].total_nutrition_good_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">b</td>
                            <td>Average members under 5 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[4].total_nutrition_medium_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[4]
                                        .total_nutrition_medium_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[4]
                                        .total_nutrition_medium_under_5 +
                                      dataFemale[4]
                                        .total_nutrition_medium_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">c</td>
                            <td>Bad members under 5 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[5].total_nutrition_poor_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[5].total_nutrition_poor_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[5].total_nutrition_poor_under_5 +
                                      dataFemale[5].total_nutrition_poor_under_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">5</td>
                            <td>Children with disability under 18 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[6].total_disability_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[6].total_disability_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[6].total_disability_under_18 +
                                      dataFemale[6].total_disability_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">6</td>
                            <td>
                              Number of children attending school under 18
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[7].total_education_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[7].total_education_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[7].total_education_under_18 +
                                      dataFemale[7].total_education_under_18
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">7</td>
                            <td>Number of members with chronic diseases</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[8].total_chronic_disease
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[8].total_chronic_disease
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[8].total_chronic_disease +
                                      dataFemale[8].total_chronic_disease
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">8</td>
                            <td>Number of elders above 60 years</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[9].total_elder : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[9].total_elder : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[9].total_elder +
                                      dataFemale[9].total_elder
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">9</td>
                            <td>
                              Number of unemployed youth between 18-35 yrs
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale ? dataMale[10].total_unemployed : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[10].total_unemployed
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[10].total_unemployed +
                                      dataFemale[10].total_unemployed
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">10</td>
                            <td>NNumber of births in a year</td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale ? dataMale[11].total_birth_1 : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[11].total_birth_1 : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[11].total_birth_1 +
                                      dataFemale[11].total_birth_1
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">11</td>
                            <td>
                              Number of deaths in a year Children under 5 years
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale ? dataMale[12].total_death_1 : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale ? dataFemale[12].total_death_1 : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[12].total_death_1 +
                                      dataFemale[12].total_death_1
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">12</td>
                            <td>
                              Number of deaths in a year Five years and above
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale
                                    ? dataMale[13].total_death_above_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataFemale
                                    ? dataFemale[13].total_death_above_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[13].total_death_above_5 +
                                      dataFemale[13].total_death_above_5
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">13</td>
                            <td colSpan={4}>
                              Number of household members with mosquito net
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">a</td>
                            <td>
                              Number of household members who are using mosquito
                              net
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[14].total_use_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[14].total_use_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[14].total_use_net +
                                      dataFemale[14].total_use_net
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">b</td>
                            <td>
                              Number of household members who are using Treated
                              mosquito net
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[16].total_treated_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[16].total_treated_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[16].total_treated_net +
                                      dataFemale[16].total_treated_net
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">c</td>
                            <td>
                              Number of household members who are using
                              Untreated mosquito net
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[15].total_not_treated_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[15].total_not_treated_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[15].total_not_treated_net +
                                      dataFemale[15].total_not_treated_net
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">d</td>
                            <td>
                              Number of household members who are not using
                              mosquito net
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[17].total_not_use_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[17].total_not_use_net : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[17].total_not_use_net +
                                      dataFemale[17].total_not_use_net
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">14</td>
                            <td colSpan={4}>
                              Number of household members with identity
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">a</td>
                            <td>ZAN ID</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[19].total_zan_id : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[19].total_zan_id : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[19].total_zan_id +
                                      dataFemale[19].total_zan_id
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">b</td>
                            <td>National ID (NIDA)</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[20].total_nida : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[20].total_nida : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[20].total_nida +
                                      dataFemale[20].total_nida
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">c</td>
                            <td>Birth registration No</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[18].total_birth_cert : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[18].total_birth_cert : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[18].total_birth_cert +
                                      dataFemale[18].total_birth_cert
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="text-end">d</td>
                            <td>Pasport No</td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataMale ? dataMale[21].total_pasport : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={dataFemale ? dataFemale[21].total_pasport : 0}
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                            <td className="text-end">
                              <NumericFormat
                                value={
                                  dataMale && dataFemale
                                    ? dataMale[21].total_pasport +
                                      dataFemale[21].total_pasport
                                    : 0
                                }
                                displayType="text"
                                thousandSeparator
                                prefix=""
                                renderText={(value) => <span>{value}</span>}
                              />
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                    <div className="row">{loading && <Loading />}</div>
                    {!loading && loadError && (
                      <div className="alert alert-warning">
                        <i className="ri-error-warning-line me-1"></i>{loadError}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
